import { Link } from "react-router";
import { breadcrumbJsonLd } from "@/lib/jsonld";

import { JsonLd } from "./JsonLd";

export type Crumb = { name: string; href: string };

/**
 * The trail above an interior page's heading.
 *
 * `light` is for a banner with a photograph behind it, where the ordinary muted
 * grey would sit on a dark scrim. The structured data is the same either way.
 */
export function Breadcrumbs({ trail, tone = "dark" }: { trail: Crumb[]; tone?: "dark" | "light" }) {
  const light = tone === "light";
  return (
    <>
      <nav aria-label="Breadcrumb" className="text-[0.875rem]">
        <ol className={`flex flex-wrap items-center gap-x-2 gap-y-1 ${light ? "text-white/90" : "text-muted"}`}>
          {trail.map((crumb, i) => {
            const isLast = i === trail.length - 1;
            return (
              <li key={crumb.href} className="flex items-center gap-2">
                {isLast ? (
                  <span aria-current="page" className={light ? "text-white" : "text-ink"}>
                    {crumb.name}
                  </span>
                ) : (
                  <Link
                    to={crumb.href}
                    className={`underline underline-offset-4 ${light ? "hover:text-white" : "hover:text-navy"}`}
                  >
                    {crumb.name}
                  </Link>
                )}
                {!isLast ? <span aria-hidden="true">/</span> : null}
              </li>
            );
          })}
        </ol>
      </nav>
      <JsonLd data={breadcrumbJsonLd(trail)} />
    </>
  );
}
